module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/home/galleries/neera_green_space.png";